import companies from 'api/companies'
import * as types from '../mutation-types'
import * as namedTypes from '../namespaced-mutation-types'

const Promise = window.Promise || require('promise')

export const addVacancy = ({ commit, rootState }, payload) => {
  if (rootState.manipulators.token !== '') {
    return companies.addVacancy(rootState.manipulators.token, payload).then((data) => {
      return Promise.resolve(data.results)
    }, (err) => {
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const updateVacancy = ({ commit, rootState }, payload) => {
  if (rootState.manipulators.token !== '') {
    return companies.updateVacancyById(
      rootState.manipulators.token,
      payload.vacancyId,
      payload).then((data) => {
        return Promise.resolve(data.results)
      }, (err) => {
        return Promise.reject(err)
      })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const fetchVacancies = ({ commit, rootState, state }, params = { page: 1 }) => {
  if (typeof rootState.utilities.vacanciesLoadingTimeout !== 'undefined') {
    clearTimeout(rootState.utilities.vacanciesLoadingTimeout)
    commit(namedTypes.VACANCIES_LOADING, false, { root: true })
    commit(namedTypes.VACANCIES_LOADING_TIMEOUT, undefined, { root: true })
  }

  commit(namedTypes.VACANCIES_LOADING, true, { root: true })
  commit(namedTypes.VACANCIES_LOADING_TIMEOUT, setTimeout(function () {
    if (typeof state.vacancies.isQueryAnd !== 'undefined') {
      params = {
        is_query_and: (state.vacancies.isQueryAnd ? 'yes' : 'no'),
        ...params
      }
    } else {
      params = {
        is_query_and: 'yes',
        ...params
      }
    }
    return companies.getVacancies(rootState.users.token, params).then((data) => {
      commit(types.VACANCIES, data.results)
      commit(namedTypes.VACANCIES_LOADING, false, { root: true })
      commit(namedTypes.VACANCIES_LOADING_TIMEOUT, undefined, { root: true })
      return Promise.resolve(data.results)
    }, (err) => {
      commit(types.VACANCIES, {})
      commit(namedTypes.VACANCIES_LOADING, false, { root: true })
      commit(namedTypes.VACANCIES_LOADING_TIMEOUT, undefined, { root: true })
      return Promise.reject(err)
    })
  }, 300), { root: true })
}

export const fetchManipulatorCompanyVacancy = ({ commit, rootState }, id = '') => {
  if (rootState.manipulators.token !== '') {
    return companies.getManipulatorCompanyVacancyById(
        rootState.manipulators.token,
        rootState.manipulators.userData.id,
        id
      ).then((data) => {
        return Promise.resolve(data.results)
      }, (err) => {
        return Promise.reject(err)
      })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const fetchVacancyEntryByAlias = ({ commit, rootState }, alias = '') => {
  return companies.getVacancyByAlias(rootState.users.token, alias).then((data) => {
    commit(types.VACANCY_ENTRY, data.results)
    return Promise.resolve(data.results)
  }, (err) => {
    return Promise.reject(err)
  })
}

export const fetchSimilarVacancies = ({ commit, rootState }, { id, params }) => {
  if (typeof params === 'undefined') {
    params = {
      similar: true,
      page: 1,
      limit: 3
    }
  }
  params = Object.assign(params, {
    similar: true
  })
  return companies.getSimilarVacancies(rootState.users.token, id, params).then((data) => {
    commit(types.VACANCY_SIMILAR_VACANCIES, data.results)
    return Promise.resolve(data.results)
  }, (err) => {
    return Promise.reject(err)
  })
}



// WEBPACK FOOTER //
// ./src/vuex/vacancies/actions.js